import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Document } from '../models/document';
import { updateDocumentEndpoint } from './const';

export const updateDocument = (document: Document) => {
    return getHttpClient().post({ url: updateDocumentEndpoint, data: JSON.stringify(document) });
};
